// extracted by mini-css-extract-plugin
export default {"wrap":"InstallOnAssetStep4_wrap__HtfkX","icon":"InstallOnAssetStep4_icon__-x98S","body":"InstallOnAssetStep4_body__vuCql"};